var _mask, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFangjian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4120_18736",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1H1V8H3V15H9V9H10V12H14.6429V4H13H10H7V1Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1H1V8H3V15H9V9H10V12H14.6429V4H13H10H7V1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V0H0V1H1ZM7 1H8V0H7V1ZM1 8H0V9H1V8ZM3 8H4V7H3V8ZM3 15H2V16H3V15ZM9 15V16H10V15H9ZM9 9V8H8V9H9ZM10 9H11V8H10V9ZM10 12H9V13H10V12ZM14.6429 12V13H15.6429V12H14.6429ZM14.6429 4H15.6429V3H14.6429V4ZM7 4H6V5H7V4ZM1 2H7V0H1V2ZM2 8V1H0V8H2ZM3 7H1V9H3V7ZM4 15V8H2V15H4ZM9 14H3V16H9V14ZM8 9V15H10V9H8ZM10 8H9V10H10V8ZM9 9V12H11V9H9ZM10 13H14.6429V11H10V13ZM15.6429 12V4H13.6429V12H15.6429ZM14.6429 3H13V5H14.6429V3ZM10 5H13V3H10V5ZM7 5H10V3H7V5ZM6 1V4H8V1H6Z",
    fill: "black",
    mask: "url(#path-1-inside-1_4120_18736)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.5,
    width: 5,
    height: 6,
    fill: "#0094FF",
    fillOpacity: 0.2,
    stroke: "#0094FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFangjian);
export default __webpack_public_path__ + "static/media/fangjian.a902ddbd52c6a5ef5d6fbe8f83f9fd48.svg";
export { ForwardRef as ReactComponent };